import { Link } from "react-router-dom/cjs/react-router-dom";
import { Element } from "react-scroll";

export default function chinhSachHuyDoiTraHoanTien() {
  return (
    <div className="container chinh-sach mt-6">
      <div className="chinh-sach-huy-doi-tra  list-chinhsach px-4">
        <h5 className="fw-bold text-center text-primary">
          CHÍNH SÁCH HỦY, ĐỔI TRẢ, HOÀN TIỀN CHUNG
        </h5>
        <div className="content">
          <p>
            Dưới đây là chính sách hủy đơn hàng, đổi trả hàng, hoàn tiền của
            GIGA.vn áp dụng chung cho tất cả các sản phẩm{" "}
            <i>
              (đối với các sản phẩm thương hiệu <strong>ECOVACS</strong>, chúng
              tôi có thêm một số lưu ý riêng so với Chính sách chung này, Quý
              khách vui lòng xem chi tiết{" "}
              <Link
                className="text-primary text-decoration-underline cursor-pointer"
                to="section2"
                spy={true}
                smooth={true}
                duration={500}
              >
                tại đây
              </Link>
              )
            </i>
            .
          </p>
          <h6 className="mt-3 fw-bold">1. CHÍNH SÁCH HỦY ĐƠN HÀNG</h6>
          <p className="mb-2">
            Quý khách được thực hiện hủy đơn hàng trong vòng 24h kể từ thời điểm
            Quý khách thanh toán thành công. Quý khách vui lòng liên hệ với
            Chúng tôi theo số điện thoại 1900.633.870 hoặc địa chỉ email
            info@giga.vn để được hỗ trợ hủy đơn hàng.
          </p>
          <ul className="list-unstyled">
            <li className="mb-2">
              <p>
                - Nếu quý khách hủy đơn hàng trước khi hàng được vận chuyển,
                thông thường là trong vòng 1 giờ kể từ lúc nhân viên bán hàng
                liên hệ xác nhận đặt hàng, Chúng tôi sẽ hoàn trả 100% tiền cho
                những quý khách đã thanh toán.
              </p>
            </li>
            <li className="mb-2">
              <p>
                - Nếu quý khách hủy đơn hàng sau khi hàng đã được vận chuyển,
                Chúng tôi sẽ giải quyết hoàn tiền cho quý khách sau khi đã trừ
                các chi phí phát sinh của đơn hàng như: phí vận chuyển, phí
                thanh toán, phí đóng gói,….
              </p>
            </li>
            <li className="mb-2">
              <p>
                - Để biết tình trạng hiện tại của đơn hàng, quý khách vui lòng
                xem trong mục Tra cứu đơn hàng trên website gigadigital.vn hoặc
                liên hệ theo số điện thoại 1900.633.870 để được hỗ trợ.
              </p>{" "}
            </li>
            <li className="mb-2">
              <p>
                - Quá thời gian qui định trên, mọi yêu cầu hủy đơn hàng của Quý
                khách sẽ không được chấp nhận.
              </p>
            </li>
          </ul>

          <h6 className="mt-3 fw-bold">2. CHÍNH SÁCH ĐỔI TRẢ</h6>
          <p className="mb-2">
            <strong>
              A. Nếu sản phẩm có lỗi phần cứng do nhà sản xuất, đủ điều kiện bảo
              hành.
            </strong>
          </p>
          <div className="table-responsive">
            <table className="border-1 mb-3">
              <thead>
                <tr>
                  <th style={{ minWidth: 80 }}></th>
                  <th
                    className="text-center text-primary"
                    style={{ minWidth: 250 }}
                  >
                    Trong vòng 15 ngày đầu
                  </th>
                  <th
                    className="text-center text-primary"
                    style={{ minWidth: 250 }}
                  >
                    Từ ngày thứ 16 tới hết thời hạn bảo hành của sản phẩm
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="text-center">Phí đổi trả</td>
                  <td className="middle">
                    <ul className="list-unstyled">
                      <li className="mb-2">
                        <p>
                          Quý khách được đổi mới miễn phí sang sản phẩm cùng
                          loại.
                        </p>
                      </li>
                      <li className="mb-2">
                        <p>
                          <i>
                            Trường hợp hư hỏng phụ kiện rời đi kèm có thể tự
                            thay thế (pin, dây cáp, bộ sạc, điều khiển từ xa,
                            chổi, giẻ lau, bánh xe,…) do lỗi nhà sản xuất, Quý
                            khách sẽ được đổi mới phụ kiện tương ứng, không đổi
                            mới nguyên bộ sản phẩm.
                          </i>
                        </p>
                      </li>
                      <li className="mb-2">
                        <p>
                          <i>
                            Trường hợp GIGA.vn không còn sẵn hàng sản phẩm cùng
                            loại để thực hiện đổi cho Quý khách, Quý khách có
                            thể lựa chọn:
                          </i>
                        </p>
                      </li>
                      <li className="mb-2">
                        <p>
                          <i>
                            + Đổi sang sản phẩm khác thanh toán thêm phần tiền
                            chênh lệch, sản phẩm đổi được áp dụng mức giá ưu đãi
                            so với giá niêm yết dành riêng cho từng trường hợp.
                          </i>
                        </p>
                      </li>
                      <li>
                        <p>
                          <i>+ Hoặc áp dụng chính sách trả hàng hoàn tiền;</i>
                        </p>
                      </li>
                    </ul>
                  </td>
                  <td>
                    <ul className="list-unstyled">
                      <li className="mb-2">
                        <p>
                          Chúng tôi thực hiện bảo hành bằng cách sửa chữa thay
                          thế linh kiện. Trường hợp không thể sửa chữa sẽ đổi
                          mới miễn phí sang sản phẩm tương đương.
                        </p>
                      </li>
                      <li className="mb-2">
                        <p>
                          <i>
                            Trường hợp chúng tôi không còn/không có ngay sản
                            phẩm cùng chủng loại để đổi cho Quý khách, Giga sẽ
                            đổi mới sang sản phẩm tương đương về công năng,
                            thiết kế, giá trị (có thể là sản phẩm trưng
                            bày/không nguyên seal).
                          </i>
                        </p>
                      </li>
                      <li className="mb-2">
                        <p>
                          <i>
                            Nếu Quý khách có nhu cầu đổi sang sản phẩm khác có
                            giá trị cao hơn sản phẩm ban đầu, Quý khách vui lòng
                            thanh toán thêm giá trị chênh lệch (không áp dụng
                            đổi trả sản phẩm thấp hơn giá trị sản phẩm ban đầu).
                          </i>
                        </p>
                      </li>
                    </ul>
                  </td>
                </tr>
                <tr>
                  <td className="text-center">Phí vận chuyển</td>
                  <td colSpan={2} className="middle">
                    <p className="mt-3">
                      GIGA hỗ trợ miễn phí vận chuyển 2 chiều:
                    </p>
                    <ul className="list-unstyled">
                      <li className="mb-2">
                        <p>
                          - Áp dụng cho các thương hiệu: Ecovacs, Tineco, Lumias, Kingsmith, New Widetech, Mibro, Kieslect do GIGA phân phối và đủ điều kiện bảo hành theo quy định của GIGA.
                        </p>
                      </li>
                      <li className="mb-2">
                        <p>
                            - Thông qua các đơn vị chuyển phát nhanh: Viettel Post, Newpost, Nhất Tín, Giao hàng Tiết kiệm và giao hàng nội thành qua các ứng dụng Ahamove, Lalamove, Grab, Xanh SM (áp dụng với Xe máy & Xe van 500kg).
                        </p>
                      </li>
                      <li>
                        <p>
                          - Chiều gửi đến, Quý khách chọn Người nhận thanh toán. Chiều trả hàng: GIGA chủ động thanh toán 100%.
                        </p>
                      </li>
                    </ul>
                  </td>
                  
                </tr>
                <tr>
                  <td className="text-center">Thời gian xử lý đổi trả </td>
                  <td colSpan={2}>
                    {" "}
                    Trong vòng 7 ngày làm việc kể từ khi chúng tôi nhận được sản
                    phẩm hoàn trả và kiểm tra, xác nhận đủ điều kiện đổi trả.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <p className="mb-2">
            <strong>
              B. Nếu sản phẩm không có lỗi phần cứng do nhà sản xuất:
            </strong>
          </p>
          <p className="my-3">
            <strong>Điều kiện đổi trả:</strong>
          </p>
          <ul className="list-unstyled">
            <li className="mb-2">
              <p>
                - Sản phẩm đổi trả phải giữ nguyên 100% hình dạng ban đầu, không
                bị xước, cấn, móp vỡ…, không bị cải tạo hoặc can thiệp thay đổi
                công năng máy mà không phải do GIGA.vn chỉ định.
              </p>
            </li>
            <li className="mb-2">
              <p>
                - Sản phẩm đổi trả phải phải có đầy đủ hộp và phụ kiện đi kèm:
              </p>
              <ul style={{ listStyleType: "none" }} className="mt-2">
                <li className="mb-2">
                  <p>
                    + Trường hợp mất hộp thu phí 5% giá trị hóa đơn mua
                    hàng;{" "}
                  </p>
                </li>
                <li className="mb-2">
                  <p>
                    + Trường hợp mất phụ kiện thu phí tối đa 5% giá trị hóa đơn
                    mua hàng.
                  </p>
                </li>
              </ul>
            </li>
            <li className="mb-2">
              <p>
                - Sản phẩm chính phải được hoàn trả kèm toàn bộ hàng khuyến mãi
                ở trạng thái nguyên vẹn chưa qua sử dụng. Nếu hàng khuyến mãi
                không đủ điều kiện hoàn trả, GIGA.vn sẽ thu phí hàng khuyến mãi
                theo mức giá đã được công bố tại thời điểm bán sản phẩm chính.
              </p>
            </li>
            <li className="mb-2">
              <p>
                - Sản phẩm chỉ được dùng cho mục đích sử dụng cá nhân, KHÔNG áp
                dụng đổi trả sản phẩm được sử dụng cho mục đích thương mại.
              </p>
            </li>
            <li className="mb-2">
              <p>
                - Chỉ được đổi sang sản phẩm giá trị CAO HƠN hoặc BẰNG sản phẩm
                đã mua.
              </p>
            </li>
            <li className="mb-2">
              <p>- Chỉ được áp dụng 1 lần duy nhất với 1 sản phẩm.</p>
            </li>
          </ul>
          <table className="border-1 my-3 w-100">
            <thead>
              <tr>
                <th style={{ minWidth: 80 }}></th>
                <th className="text-center text-primary">
                  Trong vòng 15 ngày đầu
                </th>
                <th className="text-center text-primary">Từ ngày thứ 16</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="text-left">Phí đổi trả</td>
                <td className="middle">
                  <ul className="list-unstyled mb-0">
                    <li className="mb-2">
                      <p>
                        - Phí 20% giá mua: nếu sản phẩm còn mới nguyên vẹn chưa
                        qua sử dụng và đầy đủ hộp, phụ kiện.
                      </p>
                    </li>
                    <li className="">
                      <p>
                        - Phí 30% giá mua: nếu sản phẩm đã qua sử dụng, còn đầy
                        đủ hộp, phụ kiện.
                      </p>
                    </li>
                  </ul>
                </td>
                <td rowSpan={3} className="text-center">
                  Không áp dụng chính sách đổi trả.
                </td>
              </tr>
              <tr>
                <td className="text-left">Phí vận chuyển</td>
                <td>
                  Quý khách vui lòng thanh toán phí vận chuyển 2 chiều (khi gửi
                  trả sản phẩm ban đầu và khi nhận lại sản phẩm được đổi mới).
                </td>
              </tr>
              <tr>
                <td className="text-left">Thời gian xử lý đổi trả </td>
                <td>
                  {" "}
                  Trong vòng 7 ngày làm việc kể từ khi chúng tôi nhận được sản
                  phẩm hoàn trả và kiểm tra, xác nhận đủ điều kiện đổi trả.
                </td>
              </tr>
            </tbody>
          </table>
          <p className="mb-2">
            <strong>C. Sản phẩm lỗi do người sử dụng.</strong>
          </p>
          <ul className="list-unstyled">
            <li className="mb-2">
              <p>
                Không áp dụng chính sách đổi trả. Trường hợp này, GIGA.vn hỗ trợ
                Quý khách chuyển sản phẩm đến Trung tâm bảo hành của hãng hoặc
                Trung tâm bảo hành của GIGA.vn, khách hàng vui lòng thanh toán
                phí sửa chữa, thay thế các linh kiện, chi phí vận chuyển, chi
                phí khác liên quan nếu có.
              </p>
            </li>
          </ul>
          <h6 className="mt-3 fw-bold">3. CHÍNH SÁCH HOÀN TIỀN</h6>
          <p className="mb-2">
            Nếu sản phẩm bị lỗi phần cứng do nhà sản xuất nhưng Quý khách không
            có nhu cầu đổi sang sản phẩm khác theo chính sách bảo hành, GIGA.vn
            sẽ áp dụng chính sách trả hàng hoàn tiền như sau:
          </p>
          <ul className="list-unstyled">
            <p className="mb-2">
              <strong>Điều kiện trả hàng hoàn tiền:</strong>
            </p>
            <li className="mb-2">
              <p>
                - Chính sách trả hàng hoàn tiền chỉ áp dụng cho sản phẩm có lỗi
                phần cứng do nhà sản xuất, đủ điều kiện bảo hành.
              </p>
            </li>
            <li className="mb-2">
              <p>
                - Sản phẩm hoàn trả phải giữ nguyên 100% hình dạng ban đầu,
                không bị xước, cấn, móp vỡ…, không bị cải tạo hoặc can thiệp
                thay đổi công năng máy mà không phải do GIGA.vn chỉ định.
              </p>
            </li>
            <li className="mb-2">
              <p>
                - Sản phẩm hoàn trả phải phải có đầy đủ hộp và phụ kiện đi kèm:
              </p>
              <ul style={{ listStyleType: "none" }} className="mt-2">
                <li>
                  + Trường hợp mất hộp thu phí 5% giá trị hóa đơn mua hàng;{" "}
                </li>
                <li>
                  + Trường hợp mất phụ kiện thu phí tối đa 5% giá trị hóa đơn
                  mua hàng.{" "}
                </li>
              </ul>
            </li>
            <li className="mb-2">
              <p>
                - Sản phẩm chính phải được hoàn trả kèm toàn bộ hàng khuyến mãi
                ở trạng thái nguyên vẹn chưa qua sử dụng. Nếu hàng khuyến mãi
                không đủ điều kiện hoàn trả, GIGA.vn sẽ thu phí hàng khuyến mãi
                theo mức giá đã được công bố tại thời điểm bán sản phẩm chính.
              </p>
            </li>
            <li className="mb-2">
              <p>
                - Sản phẩm chỉ được dùng cho mục đích sử dụng cá nhân, KHÔNG áp
                dụng hoàn trả sản phẩm được sử dụng cho mục đích thương mại
              </p>
            </li>
          </ul>
          <table className="border-1 mb-3 w-100">
            <thead>
              <tr>
                <th className="text-center color-table-header">
                  Trong 15 ngày đầu tiên kể từ ngày mua hàng
                </th>
                <th className="text-center color-table-header">
                  Từ ngày thứ 15 trở đi kể từ ngày mua hàng
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="text-center">Hoàn đến 100% giá trị hóa đơn</td>
                <td className="text-center">
                  Không áp dụng chính sách hoàn tiền
                </td>
              </tr>
            </tbody>
          </table>
          <p className="mt-3">
            <i>
              Lưu ý: Tùy theo tình trạng của máy Quý khách sẽ được thông báo mức
              hoàn tiền cụ thể sau khi trừ đi phí mất phụ kiện, vỏ hộp, quà tặng
              đi kèm (nếu có).
            </i>
          </p>
        </div>
      </div>

      <div className="chinh-sach-tra-hoan-tien list-chinhsach mt-5 px-4">
        <Element name="section2" classID="section2"></Element>
        <h5 className="fw-bold text-center text-primary">
          CHÍNH SÁCH ĐỔI TRẢ HÀNG – HOÀN TIỀN CỦA GIGA.VN ĐỐI VỚI SẢN PHẨM
          ECOVACS
        </h5>
        <div className="content">
          <p>
            <i>
              Chính sách trả hàng, hoàn tiền này được áp dụng cho sản phẩm mang
              thương hiệu ECOVACS, các nội dung không được sửa đổi, bổ sung hay
              quy định chi tiết bởi chính sách riêng này sẽ tuân thủ theo quy
              định hủy đơn hàng, trả hàng chung của GIGA.vn.
            </i>
          </p>
          <h6 className="mt-3 fw-bold">
            1. ĐIỀU KIỆN ĐỔI TRẢ HÀNG – HOÀN TIỀN
          </h6>
          <ul className="list-unstyled">
            <li className="mb-2">
              <p>
                - Trong thời gian 30 ngày kế từ ngày mua sản phẩm mà: sản phẩm
                bị gặp lỗi phần cứng hoặc sản phẩm không gặp lỗi nhưng Quý khách
                có nhu cầu đổi sang mã sản phẩm khác do nhu cầu cá nhân đồng
                thời đáp ứng đủ điều kiện bảo hành miễn phí với sản phẩm Ecovacs
                như nêu trên.{" "}
              </p>
            </li>
            <li className="mb-2">
              <p>
                - Sản phẩm đổi trả phải giữ nguyên 100% hình dạng ban đầu, không
                bị xước, cấn, móp vỡ…, không bị cải tạo hoặc can thiệp thay đổi
                công năng máy mà không phải do Ecovacs chỉ định.
              </p>
            </li>
            <li className="mb-2">
              <p>
                - Sản phẩm đổi trả phải phải có đầy đủ hộp và phụ kiện đi kèm:
              </p>
              <ul style={{ listStyleType: "none" }} className="mt-2">
                <li>
                  <p>
                    + Trường hợp mất hộp thu phí 5% giá trị hóa đơn mua
                    hàng;{" "}
                  </p>
                </li>
                <li>
                  <p>
                    +  Trường hợp mất phụ kiện thu phí tối đa 5% giá trị hóa
                    đơn mua hàng.{" "}
                  </p>
                </li>
              </ul>
            </li>
            <li className="mb-2">
              <p>
                - Sản phẩm chính phải được hoàn trả kèm toàn bộ hàng khuyến mãi
                ở trạng thái nguyên vẹn chưa qua sử dụng. Nếu hàng khuyến mãi
                không đủ điều kiện hoàn trả, Giga sẽ thu phí hàng khuyến mãi
                theo mức giá đã được công bố tại thời điểm bán sản phẩm chính.
              </p>
            </li>
            <li className="mb-2">
              <p>
                - Sản phẩm chỉ được dùng cho mục đích sử dụng cá nhân, KHÔNG áp
                dụng đổi trả sản phẩm được sử dụng sản phẩm cho mục đích thương
                mại.
              </p>
            </li>
            <li className="mb-2">
              <p>
                - Chỉ được đổi sang sản phẩm giá trị CAO HƠN hoặc BẰNG sản phẩm
                đã mua.
              </p>
            </li>
            <li className="mb-2">
              <p>- Chỉ được áp dụng 1 lần duy nhất với 1 sản phẩm.</p>
            </li>
          </ul>
          <h6 className="mt-3 fw-bold">2. CHÍNH SÁCH ĐỔI TRẢ HÀNG </h6>
          <div className="table-responsive">
            <table className="border-1 my-3">
              <thead>
                <tr>
                  <th
                    className="text-center color-table-header"
                    style={{ minWidth: 150 }}
                  >
                    Thời gian/Điều kiện áp dụng
                  </th>
                  <th
                    className="text-center color-table-header"
                    style={{ minWidth: 250 }}
                  >
                    Từ ngày 1 đến ngày thứ 15 kể từ ngày mua hàng
                  </th>
                  <th
                    className="text-center color-table-header"
                    style={{ minWidth: 250 }}
                  >
                    Từ ngày thứ 16 đến ngày thứ 30 kể từ ngày mua hàng
                  </th>
                  <th
                    className="text-center color-table-header"
                    style={{ minWidth: 250 }}
                  >
                    Từ ngày thứ 31 trở đi kể từ ngày mua hàng
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Nếu sản phẩm gặp lỗi phần cứng do nhà sản xuất</td>
                  <td>
                    <p className="mb-2">
                      Quý khách được đổi mới miễn phí sang sản phẩm cùng loại
                    </p>
                    <p className="mb-2">
                      <i>
                        Trường hợp hư hỏng phụ kiện rời đi kèm có thể tự thay
                        thế (dây cáp, bộ sạc, chổi, giẻ lau, đế lau, bình nước,
                        nắp chắn, ...) do lỗi nhà sản xuất, Quý khách sẽ được
                        đổi mới phụ kiện tương ứng, không đổi mới nguyên bộ sản
                        phẩm
                      </i>
                    </p>
                    <ul className="list-unstyled">
                      <p className="mb-2">
                        Trường hợp GIGA.vn không còn sẵn hàng sản phẩm cùng loại
                        để thực hiện đổi cho quý khách, Quý khách có thể lựa
                        chọn:
                      </p>

                      <li className="mb-2">
                        <p>
                          + Nhận gói Premium Care miễn phí (thông tin chi tiết
                          gói{" "}
                          <a
                            href={
                              "https://gigadigital.vn/tin-tuc/khuyen-mai/sam-robot-hut-bui-ecovacs-nhan-ngay-bao-duong-xin"
                            }
                            target="_blank"
                            className="text-primary text-decoration-underline"
                          >
                            tại đây
                          </a>{" "}
                          );
                        </p>
                      </li>
                      <li className="mb-2">
                        <p>
                          + Hoặc đổi sang sản phẩm khác thanh toán thêm phần
                          tiền chênh lệch, sản phẩm đổi được áp dụng mức giá ưu
                          đãi so với giá niêm yết dành riêng cho từng trường
                          hợp.
                        </p>
                      </li>
                      <li className="">
                        <p>+ Hoặc áp dụng chính sách trả hàng hoàn tiền.</p>
                      </li>
                    </ul>
                  </td>
                  <td>
                    Phí 20% giá trị hóa đơn mua sản phẩm + Bù tiền chênh lệch
                    nếu đổi sản phẩm giá trị cao hơn.
                  </td>
                  <td rowSpan={4} className="text-center">
                    Chỉ áp dụng chính sách bảo hành, không áp dụng chính sách
                    đổi trả hàng.
                  </td>
                </tr>

                <tr>
                  <td className="text-left">
                    Nếu sản phẩm không gặp lỗi phần cứng do nhà sản xuất nhưng
                    khách hàng có nhu cầu đổi sang mẫu sản phẩm khác
                  </td>
                  <td colSpan={2}>
                    {" "}
                    Phí 50% giá trị hóa đơn mua sản phẩm + Bù tiền chênh lệch
                    nếu đổi sản phẩm giá trị cao hơn.
                  </td>
                </tr>
                <tr>
                  <td className="text-left">Áp dụng chung </td>
                  <td colSpan={2}>
                    {" "}
                    Trường hợp Khách hàng muốn đổi hàng full box (nguyên thùng,
                    nguyên hộp) thì Khách hàng sẽ trả thêm phí lấy full box
                    tương đương 20% giá trị hóa đơn.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <h6 className="mt-3 fw-bold">3. CHÍNH SÁCH TRẢ HÀNG HOÀN TIỀN</h6>
          <p className="mb-2">
            Nếu sản phẩm bị lỗi phần cứng do nhà sản xuất nhưng Quý khách không
            có nhu cầu đổi sang sản phẩm khác, GIGA.vn sẽ áp dụng chính sách trả
            hàng hoàn tiền như sau:
          </p>
          <table className="border-1 my-3 w-100">
            <thead>
              <tr>
                <th className="text-center color-table-header">
                  Trong 30 ngày đầu tiên kể từ ngày mua hàng
                </th>
                <th className="text-center color-table-header">
                  Từ ngày thứ 31 đến 60 kể từ ngày mua hàng
                </th>
                <th className="text-center color-table-header">
                  Từ ngày thứ 61 trở đi kể từ ngày mua hàng
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="text-center">Hoàn đến 65% giá trị hóa đơn</td>
                <td className="text-center">Hoàn đến 50% giá trị hóa đơn</td>
                <td className="text-center" rowSpan={2}>
                  Không áp dụng chính sách hoàn tiền.{" "}
                </td>
              </tr>
              <tr>
                <td colSpan={2} className="text-center">
                  <i>
                    Tùy theo tình trạng của máy Quý khách sẽ được thông báo mức
                    hoàn tiền cụ thể sau khi trừ đi phí mất phụ kiện, vỏ hộp,
                    quà tặng đi kèm (nếu có).
                  </i>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
